// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomModal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  visibility: hidden;
  display: flex;
  opacity: 0;
  -webkit-transition: all 200ms ease-in-out;
  -moz-transition: all 200ms ease-in-out;
  -ms-transition: all 200ms ease-in-out;
  -o-transition: all 200ms ease-in-out;
  transition: all 200ms ease-in-out;
  background-color: transparent;
  z-index: 1000;
}


.CustomModal-open{
  visibility: visible;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.4);
}

.CustomModal-modal{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex: 1 1;
  padding: 70px 0;
  overflow-y: auto;
}

.CustomModal-modal-container{
  width: 630px;
  max-width:100%;
  border-radius: 5px;
  background-color: #fff;
  padding: 30px;
  min-height: 200px;
}


.CustomModal-help{
  background-color: #FFFFFF;
  height: 100%;
  width: 0;
  overflow: hidden;
  /* padding: 15px; */
  -webkit-transition: all 200ms ease-in-out;
  -moz-transition: all 200ms ease-in-out;
  -ms-transition: all 200ms ease-in-out;
  -o-transition: all 200ms ease-in-out;
  transition: all 200ms ease-in-out;
}

.CustomModal-help-open{
  width: 100%;
  max-width: 350px;
}

@media screen and (max-width: 600px) {
  .CustomModal-help-open {
    max-width: 100vw !important;
  }
}

.CustomModal-Highlight{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  -webkit-transition: all 200ms ease-in-out;
  -moz-transition: all 200ms ease-in-out;
  -ms-transition: all 200ms ease-in-out;
  -o-transition: all 200ms ease-in-out;
  transition: all 200ms ease-in-out;
}

.CustomModal-Highlight * {
  box-sizing: border-box;
}

.CustomModal-hl {
  position: relative;
}

.CustomModal-Highlight .ant-form-item,.CustomModal-hl .ant-form-item{
  margin-bottom: 0 !important;
}

.CustomModal-Highlight-open{
  background-color: rgba(0, 0, 0, 0.2);
}

.CustomModal-Highlight > .CustomModal-Highlight-component{
  position: absolute;
  background-color: #fff;
  border-radius: 5px;
  transition: all 300ms;
  transition-delay: 30ms;
  max-height: 100vh;
  overflow-y: auto;
}

.Workhistory-form-project-title button{
  height: 19px;
  padding: 0;
  display: flex;
  color: #56A8F7 !important;
  font-size: 14px;
  margin: 15px 0;
}



.CustomModal-modal-head-title{
  font-size: 28px;
  font-weight: 600;
  color: #444444;
}

.CustomModal-modal-head > span{
  font-size: 14px;
  color: #AAAAAA;
}

.CustomModal-modal-head {
  margin-bottom: 32px;
}

.CustomModal-modal-container .grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr auto auto auto;
  gap: 12px;
  grid-template-areas:
    "c1 c1 c2 c2"
    "c6 c7 c8 c9"
    "c3 c3 c3 c3"
    "c4 c4 c4 c4"
    "c5 c5 c5 c5";
}

@media screen and (max-width: 600px) {
  .CustomModal-modal-container .grid-container {
    grid-template-rows: 1fr 1fr 1fr auto auto auto;
    grid-template-areas:
      "c1 c1 c1 c1"
      "c2 c2 c2 c2"
      "c6 c7 c8 c9"
      "c3 c3 c3 c3"
      "c4 c4 c4 c4"
      "c5 c5 c5 c5";
  }
}

.c1 { grid-area: c1; }
.c2 { grid-area: c2; }
.c3 { grid-area: c3; }
.c4 { grid-area: c4; }
.c5 { grid-area: c5; }
.c6 { grid-area: c6; }
.c7 { grid-area: c7; }
.c8 { grid-area: c8; }
.c9 { grid-area: c9; }

.grid-container .ant-form-item{
  margin: 0;
}
.grid-container textarea{
  min-height: 160px;
}
.CustomModal-help-helpSectionOnly {
  position: fixed;
  top:0;
  right:0;
  bottom:0;
  width: 350px;
  display: none;
}
.CustomModal-help-helpSectionOnly-open {
  display: block;
  z-index: 1000;
}

.closeicon {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 100;
}

.open-help-button {
  position: absolute;
  bottom: 16px;
  left: 15px;
  z-index: 100;
  background: #fff;
  border-radius: 5px;
}

.CustomModal-full-width {
  width: 100% !important;
  z-index: 1000;
}

.help-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 5px;
}

.main-custom-modal-open {
  margin-right: 350px;
}

.CustomModal-Highlight-component-open {
  transform: translateX(-175px);
}

main {
  transition: all 300ms;
}

.CustomModal-Highlight-component-open textarea {
  resize: none;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/CustomModal/CustomModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,aAAa;AACf;;;AAGA;EACE,mBAAmB;EACnB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;AACnB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;;;AAIA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,0CAA0C;EAC1C,SAAS;EACT;;;;;iBAKe;AACjB;;AAEA;EACE;IACE,8CAA8C;IAC9C;;;;;;mBAMe;EACjB;AACF;;AAEA,MAAM,aAAa,EAAE;AACrB,MAAM,aAAa,EAAE;AACrB,MAAM,aAAa,EAAE;AACrB,MAAM,aAAa,EAAE;AACrB,MAAM,aAAa,EAAE;AACrB,MAAM,aAAa,EAAE;AACrB,MAAM,aAAa,EAAE;AACrB,MAAM,aAAa,EAAE;AACrB,MAAM,aAAa,EAAE;;AAErB;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,KAAK;EACL,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".CustomModal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  visibility: hidden;\n  display: flex;\n  opacity: 0;\n  -webkit-transition: all 200ms ease-in-out;\n  -moz-transition: all 200ms ease-in-out;\n  -ms-transition: all 200ms ease-in-out;\n  -o-transition: all 200ms ease-in-out;\n  transition: all 200ms ease-in-out;\n  background-color: transparent;\n  z-index: 1000;\n}\n\n\n.CustomModal-open{\n  visibility: visible;\n  opacity: 1;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.CustomModal-modal{\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex: 1 1;\n  padding: 70px 0;\n  overflow-y: auto;\n}\n\n.CustomModal-modal-container{\n  width: 630px;\n  max-width:100%;\n  border-radius: 5px;\n  background-color: #fff;\n  padding: 30px;\n  min-height: 200px;\n}\n\n\n.CustomModal-help{\n  background-color: #FFFFFF;\n  height: 100%;\n  width: 0;\n  overflow: hidden;\n  /* padding: 15px; */\n  -webkit-transition: all 200ms ease-in-out;\n  -moz-transition: all 200ms ease-in-out;\n  -ms-transition: all 200ms ease-in-out;\n  -o-transition: all 200ms ease-in-out;\n  transition: all 200ms ease-in-out;\n}\n\n.CustomModal-help-open{\n  width: 100%;\n  max-width: 350px;\n}\n\n@media screen and (max-width: 600px) {\n  .CustomModal-help-open {\n    max-width: 100vw !important;\n  }\n}\n\n.CustomModal-Highlight{\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  z-index: 1000;\n  display: flex;\n  justify-content: flex-end;\n  -webkit-transition: all 200ms ease-in-out;\n  -moz-transition: all 200ms ease-in-out;\n  -ms-transition: all 200ms ease-in-out;\n  -o-transition: all 200ms ease-in-out;\n  transition: all 200ms ease-in-out;\n}\n\n.CustomModal-Highlight * {\n  box-sizing: border-box;\n}\n\n.CustomModal-hl {\n  position: relative;\n}\n\n.CustomModal-Highlight .ant-form-item,.CustomModal-hl .ant-form-item{\n  margin-bottom: 0 !important;\n}\n\n.CustomModal-Highlight-open{\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.CustomModal-Highlight > .CustomModal-Highlight-component{\n  position: absolute;\n  background-color: #fff;\n  border-radius: 5px;\n  transition: all 300ms;\n  transition-delay: 30ms;\n  max-height: 100vh;\n  overflow-y: auto;\n}\n\n.Workhistory-form-project-title button{\n  height: 19px;\n  padding: 0;\n  display: flex;\n  color: #56A8F7 !important;\n  font-size: 14px;\n  margin: 15px 0;\n}\n\n\n\n.CustomModal-modal-head-title{\n  font-size: 28px;\n  font-weight: 600;\n  color: #444444;\n}\n\n.CustomModal-modal-head > span{\n  font-size: 14px;\n  color: #AAAAAA;\n}\n\n.CustomModal-modal-head {\n  margin-bottom: 32px;\n}\n\n.CustomModal-modal-container .grid-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-template-rows: 1fr 1fr auto auto auto;\n  gap: 12px;\n  grid-template-areas:\n    \"c1 c1 c2 c2\"\n    \"c6 c7 c8 c9\"\n    \"c3 c3 c3 c3\"\n    \"c4 c4 c4 c4\"\n    \"c5 c5 c5 c5\";\n}\n\n@media screen and (max-width: 600px) {\n  .CustomModal-modal-container .grid-container {\n    grid-template-rows: 1fr 1fr 1fr auto auto auto;\n    grid-template-areas:\n      \"c1 c1 c1 c1\"\n      \"c2 c2 c2 c2\"\n      \"c6 c7 c8 c9\"\n      \"c3 c3 c3 c3\"\n      \"c4 c4 c4 c4\"\n      \"c5 c5 c5 c5\";\n  }\n}\n\n.c1 { grid-area: c1; }\n.c2 { grid-area: c2; }\n.c3 { grid-area: c3; }\n.c4 { grid-area: c4; }\n.c5 { grid-area: c5; }\n.c6 { grid-area: c6; }\n.c7 { grid-area: c7; }\n.c8 { grid-area: c8; }\n.c9 { grid-area: c9; }\n\n.grid-container .ant-form-item{\n  margin: 0;\n}\n.grid-container textarea{\n  min-height: 160px;\n}\n.CustomModal-help-helpSectionOnly {\n  position: fixed;\n  top:0;\n  right:0;\n  bottom:0;\n  width: 350px;\n  display: none;\n}\n.CustomModal-help-helpSectionOnly-open {\n  display: block;\n  z-index: 1000;\n}\n\n.closeicon {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  z-index: 100;\n}\n\n.open-help-button {\n  position: absolute;\n  bottom: 16px;\n  left: 15px;\n  z-index: 100;\n  background: #fff;\n  border-radius: 5px;\n}\n\n.CustomModal-full-width {\n  width: 100% !important;\n  z-index: 1000;\n}\n\n.help-btn {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  display: grid;\n  grid-auto-flow: column;\n  grid-gap: 5px;\n}\n\n.main-custom-modal-open {\n  margin-right: 350px;\n}\n\n.CustomModal-Highlight-component-open {\n  transform: translateX(-175px);\n}\n\nmain {\n  transition: all 300ms;\n}\n\n.CustomModal-Highlight-component-open textarea {\n  resize: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
